module.exports = __webpack_public_path__ + "img/terengganu.ede693d0.png";